import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Message, MessageService } from 'primeng/api';
import { ToastPositionType } from 'primeng/toast';
import { SharedEventsService } from '@fh-client-interaction-frontends/fh-providers';
import { SharedSettingsService } from '@fh-client-interaction-frontends/fh-configurations';
import { distinct, distinctUntilChanged, filter, map, Subscription } from 'rxjs';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';

@Component({
  selector: 'ui-fh-toaster-messages',
  templateUrl: './fh-toaster-messages.component.html',
  styleUrls: ['./fh-toaster-messages.component.scss'],
  providers: [MessageService]
})
export class FhToasterMessagesComponent implements OnInit, OnDestroy {
  appConfig: EnvironmentModel = new EnvironmentModel();
  position: ToastPositionType | undefined;
  key: string | undefined;
  disableColor: boolean = false;

  subscription: Subscription = new Subscription();

  constructor(
    @Inject(APP_CONFIG) appConfigTemp: EnvironmentModel,
    private messageService: MessageService,
    private sharedEventsService: SharedEventsService,
    private changeDetectorRef: ChangeDetectorRef,
    private sharedSettingsService: SharedSettingsService
  ) {
    this.appConfig = appConfigTemp;
    this.OpenToaster();
  }

  ngOnInit() {
    this.getLocalSettings();
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  OpenToaster() {
    this.subscription = this.sharedEventsService.toasterEvents.pipe(filter((data: Message) => data.key != '')).subscribe({
      next: (data: Message) => {
        this.key = data.key;

        switch (this.key) {
          case 'tl':
            this.position = 'top-left';
            break;
          case 'tr':
            this.position = 'top-right';
            break;
          case 'tc':
            this.position = 'top-center';
            break;
          case 'bc':
            this.position = 'bottom-center';
            break;
          case 'bl':
            this.position = 'bottom-left';
            break;
          case 'br':
            this.position = 'bottom-right';
            break;
          case 'c':
            this.position = 'center';
            break;
          default:
            this.position = 'top-right';
            break;
        }

        this.changeDetectorRef.detectChanges();
        this.messageService.add(data);
      }
    });
  }

  getLocalSettings() {
    this.sharedSettingsService.get().subscribe({
      next: (value: any) => {
        this.disableColor = value?.colorsDisable;
      }
    });
  }
}
